module.exports = __webpack_public_path__ + "static/media/about-you-demo.1d5c13ba.svg";